import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    gridColumn: '1/3',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      gridColumn: 'auto',
    },
  },
  content: {
    padding: 0,
  },
}));

export default useStyles;
